<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('lbl.sps.smeltingPreheatingKilnStopEdit')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/smeltingPreheatingKilnStop"><span>{{$t('tlt.smeltingPreheatingKilnStop')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/smeltingPreheatingKilnStopEdit"><span>{{$t('lbl.sps.smeltingPreheatingKilnStopEdit')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('smeltingPreheatingKilnStop')"><i
                            class="fa fa-fw fa-lg fa-minus-circle"></i><span
                            class=text>{{$t('btn.basic.cancel')}}</span></button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFSave('smeltingPreheatingKilnStop')"><i
                            class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.basic.save')}}</span></button>
                </div>
            </div>
        </div>

        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.date')}}：</label>
                                <mmf-datepicker v-model="date"></mmf-datepicker>
                            </div>
                            <div class="form-group col-md-2" style="display: none">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>location id:</label>
                                <dimSearch  validate="required" name="locId"
                                            v-model="locId" :entity="locations" submitProp="id" bindProp="id" bindId="smeltingLocation">
                                </dimSearch>                                
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.location.area')}}:</label>
                                <dimSearch  validate="required" name="locName"
                                            v-model="locName" :entity="locations" submitProp="locName" bindProp="locName" bindId="smeltingLocation">
                                </dimSearch>                                
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.shiftPlan.shiftName')}}：</label>
                                <select class="form-control" type="text" v-model="shiftName" v-validate="'required'" name="shiftName">
                                    <option value>{{ $t("lbl.basic.select.one") }}</option>
                                    <option value="甲">{{ $t("lbl.shift.A") }}</option>
                                    <option value="乙">{{ $t("lbl.shift.B") }}</option>  
                                    <option value="丙">{{ $t("lbl.shift.C") }}</option>
                                </select>
                                <span v-show="errors.has('shiftName')" class="lbl-obg">
                                    {{errors.first('shiftName')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.sps.stopNumber')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="stopNumber" name="stopNumber" v-validate="'required'">
                                <span v-show="errors.has('stopNumber')" class="lbl-obg">
                                    {{errors.first('stopNumber')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.sps.stopTime')}}：</label>
                                <!-- <input class="form-control form-control-sm" type="time" v-model="stopTime" name="stopTime"> -->
                                <mes-time-picker v-model="stopTime" name="stopTime" v-validate="'required'"></mes-time-picker>
                                <span v-show="errors.has('stopTime')" class="lbl-obg">
                                    {{errors.first('stopTime')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.sps.startTime')}}：</label>
                                <!-- <input class="form-control form-control-sm" type="time" v-model="startTime" name="startTime"> -->
                                <mes-time-picker v-model="startTime" name="startTime" v-validate="'required'"></mes-time-picker>
                                <span v-show="errors.has('startTime')" class="lbl-obg">
                                    {{errors.first('startTime')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.sps.totalStop')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="totalStop" name="totalStop" v-validate="'required'">
                                <span v-show="errors.has('totalStop')" class="lbl-obg">
                                    {{errors.first('totalStop')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.sps.stopReason')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="stopReason"  v-validate="'required'" name="stopReason">
                                <span v-show="errors.has('stopReason')" class="lbl-obg">
                                    {{errors.first('stopReason')}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
import {
        createHelpers
    } from 'vuex-map-fields';
    import {
        mapActions,mapState
    } from "vuex";
    import {
        fields
    } from "@/model/prd/productionExecution/smelting/SmeltingPreheatingKilnStop";
    import MmfDatepicker from '@/components/MmfDatepicker';
    import MesTimePicker from '@/components/MesTimePicker';
    import dimSearch from "@/components/MMFDimSearch";

    const {
        mapFields
    } = createHelpers({
        getterType: 'smeltingPreheatingKilnStop/getField',
        mutationType: 'smeltingPreheatingKilnStop/updateField',
    });
export default {
    data(){
        return {};
    },
    beforeMount() {
            this.$store.dispatch('smeltingPreheatingKilnStop/loadLocations');
    },
    computed: {
            ...mapFields(fields),
            ...mapState({
                locations: state => state.smeltingPreheatingKilnStop.locations,
            }),
        },
        methods: {
            ...mapActions("base", ["MMFbackToList", "MMFSave"]),            
        },
        components: {
            MmfDatepicker,
            MesTimePicker,
            dimSearch
        }
};
</script>